import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "react-query";
import type { DefaultTheme } from "styled-components";
import { ThemeProvider } from "styled-components";

import { ApiClientProvider } from "api/ApiClientProvider";
import { cacheClient } from "cacheClient";
import { SnackbarContextProvider } from "contexts/SnackbarContext";
import { GlobalStyle } from "GlobalStyle";
import { Router } from "router";
import { Segment } from "shared/atoms/Segment";
import { theme as Theme } from "theme";
import { muiTheme } from "theme/muiTheme";
import { CustomErrorBoundary as ErrorBoundary } from "utils/errorReporting";
import { useWindowSize } from "utils/hooks";

export function App(): JSX.Element {
  const { height } = useWindowSize();

  const themeWithVh = (theme: DefaultTheme) => ({
    ...theme,
    vh: height,
  });

  return (
    <ErrorBoundary>
      <ApiClientProvider>
        <QueryClientProvider client={cacheClient}>
          <ThemeProvider theme={themeWithVh(Theme)}>
            <MUIThemeProvider theme={muiTheme}>
              <SnackbarContextProvider>
                <Segment />
                <Router />
                <GlobalStyle />
              </SnackbarContextProvider>
            </MUIThemeProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </ApiClientProvider>
    </ErrorBoundary>
  );
}
